import { environment } from '../../environments/environment';

export let API_BASE_PATHS = environment.apiUrl;
export let API_HLC_PATHS = environment.hlcURL;
export let HLC_CLIENT_ID = environment.clientId;
export let HLC_CLIENT_SECRET = environment.clientSecret;
export let NED_BANK_ID = environment.ned_bank_id;
export let PERIGON_SURVEY_URL = environment.perigon_survey_url;
export let THIRD_PARTY_URL = environment.third_party_url;
export enum API_PATHS {
	AUTHENTICATE = '/v1/account/eap/authenticate',
	LOGIN = '/v1/security/eap/validate',
	SECURITY_USER = '/v1/security/eap/user',
	SYN_FINDUSER = '/v1/security/eap/finduser',
	SYN_UPDATEUSER = '/v1/security/eap/updateuser',
	USER_EXISTS = '/v1/security/eap/userexist',
	GETCASES = '/eap/v1/synergy/mycases',
	CASE_CREATE = '/eap/v1/synergy/create',
	CASE_DETAILS = '/eap/v1/synergy/casedetail',
	HELLO_DOCTOR = '/eap/v1/hellodoctor',
	DECRYPT_TOKEN = '/v1/sls/eap/decrypttoken',
	QUESTIONNAIRE = '/eap/v1/questionnaire',
    QUESTIONSCORE = '/eap/v1/questionnaire/getQuestionnaireResults',
    GET_REPORTS_HIERACHY = '/eap/v1/sapsreportconfig/hierarchy',
	AZURE_TOKEN = '/eap/v1/azure',
	POWER_BI_TOKEN = '/eap/v1/powerBI/generateToken',
	GET_COF_REPORTS = '/eap/v1/synergy/documents/id',
	GET_TOPICS_ELEARNING ="/eap/v1/elearning/topics",
	GET_VIDEO_URL_ELEARNING ="/eap/v1/elearning/videos",
	GET_PDF_URL_ELEARNING ="/eap/v1/elearning/documents",
	POST_QUESTION_ELEARNING ="/eap/v1/elearning/user/quiz",
	CHECK_TOPIC_PROGRESS = "/eap/v1/elearning/user/progress",
	SAVE_SURVEY = "/eap/v1/elearning/user/survey",
	POST_WATCHED_VIDEO = '/eap/v1/elearning/user/videos/watched',
	GET_WATCHED_VIDEOS = '/eap/v1/elearning/user/videos/watched',
	// POST_HLC_TOKEN = "/api/token.php",
	// POST_HLC_REDIRECT="/api/auth.php"
	POST_HLC_TOKEN = "/access_token",
	POST_HLC_REDIRECT="/auth",
	THIRD_PARTY_HLC_CALL = "/EapPortal/validateHLCUser",
	//details for below url thirdpartycall c# application
	//http://vlmmhctrprd101.metmom.mmih.biz/Wellness/thirdpartycall
	GET_HEALTH_BITE_PDF = "/EapPortal/wellbeinghub/HealthBite/getAllPdfs", 
	GET_HEALTH_BITE_PDF_BY_NAME = "/EapPortal/wellbeinghub/HealthBite/getPdfByName" 
}

export enum PERIGON_SURVEY{
	MENTAL='/mental-wellbeing/mental',
	PRE='/3776A25B-8603-4AF3-BE5E-5F8AC6691D9A/',
	POST='/20C8B9F2-5DB0-4740-94BA-13C72A3AF3DF/',
}

export enum ENVIRONMENT_VARS {
	GOOGLE_ANALYTICS_CODE = 'UA-xxxxxxxx-x',
}

export enum PR_CODES {
	EAPP057 = 'Mental Health',
	EAPP061 = 'Trauma',
	EAPP056 = 'Legal',
	EAPP052 = 'Financial',
	EAPP058 = 'Relationship',
	EAPP051 = 'Family',
	EAPP062 = 'Work related',
	EAPP053 = 'Health & lifestyle'
}